import { render } from "./profit.vue?vue&type=template&id=67a5ec38&scoped=true"
import script from "./profit.vue?vue&type=script&lang=js"
export * from "./profit.vue?vue&type=script&lang=js"

import "./profit.vue?vue&type=style&index=0&id=67a5ec38&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67a5ec38"]])

export default __exports__